/*
 * @Author: owen
 * @Date: 2022-03-29 10:56:40
 * @LastEditors: owen
 * @LastEditTime: 2022-04-24 11:47:18
 * @FilePath: \app-pcweb\src\api\user.js
 */
import request from "@/lobby_common/utils/request";
import { getLocalStorage } from "@/lobby_common/utils/auth.js";
import { encode } from "js-base64";
import store from "@/lobby_common/store";
// import md5 from "md5";
// import sha256 from "sha256";
// import { postParamStr } from "@/lobby_common/utils/utils";
const fromAppFormat = (obj) => {
  const initQuery = getLocalStorage("initQuery") || {};
  const isFromApp = Boolean(window.localStorage.getItem('isFromApp'))
  console.log("----------==========");
  console.log(initQuery);
  console.log(isFromApp);
  if (isFromApp) {
    obj.device_id = initQuery?.device_id;
    obj.app = initQuery?.ft;
  }
  return isFromApp;
};

// 一键快捷登录 1
export const visitorPost = (data) => {
  const obj = {
    ...data,
    app: "web",
    inviteCode: data.inviteCode || getLocalStorage("inviteCode") || "",
  };
  let url = "/usercenter/v1/web/register/visitor";
  const isFromApp = fromAppFormat(obj);
  if (isFromApp) {
    url = "/usercenter/v1/register/visitor";
  }
  return request({
    url,
    method: "post",
    data: obj,
  });
};

// facebook注册/登录 1
export const facebookLogin = (data) => {
  return request({
    url: "/usercenter/v1/web/register/facebook",
    method: "post",
    data: {
      ...data,
      app: "web",
      inviteCode: getLocalStorage("inviteCode") || "",
    },
  });
};
// 发邮件
export const sendEmailPost = (data) => {
  return request({
    url: "/basic/v1/email/send/userNamePwd",
    method: "post",
    data: {
      ...data,
      app: "web",
    },
  });
};

// 获取验证码
export function getCaptcha(data) {
  return request({
    url: "/basic/v1/web/sms/send/captcha",
    method: "post",
    data,
  });
}

/**
 * 修改信息
 * @param {*} data  { nickname: 昵称，avatar：头像}
 * @returns { code:0,data:{}}
 */
export const updateinfoPost = (data) =>
  request({
    url: "/usercenter/v1/user/update",
    method: "post",
    data,
  });

/**
 * 绑定手机号
 * @param {*} data ={phone： 手机号码，aptcha：验证码，password：密码 }
 * @returns { code:0,data:{}}
 */
export const bindPhonePost = (data) =>
  request({
    url: "/usercenter/v1/user/bindPhone",
    method: "post",
    data,
  });

/**
 * 绑定邀请码
 * @param {*} data ={inviteCode: 邀请码 }
 * @returns { code:0,data:{}}
 */
export const bindinvitationPost = (data) =>
  request({
    url: "/usercenter/v1/web/user/bindInviteCode",
    method: "post",
    data,
  });

// 事件上报
export const gatheringPost = (data) =>
  request({
    url: "/gathering/v1/event",
    method: "post",
    data: { ...data },
  });

// 错误上报
export const clientErrPost = (data) =>
  request({
    url: "/gathering/v1/client-error",
    method: "post",
    data: data,
  });


// 快速登录修改密码
export const updateQuickPassword = (data) =>
  request({
    url: "/usercenter/v1/user/password",
    method: "put",
    data: { ...data },
  });

// 获取邮箱验证码
export function sendEmailCaptcha(data) {
  return request({
    url: "/basic/v1/web/sms/send/email/captcha",
    method: "post",
    data,
  });
}

// 绑定邮箱
export function bindOfEmail(data) {
  return request({
    url: "/usercenter/v1/user/bindEmail",
    method: "post",
    data,
  });
}

// v1.15.0 商务合作注册
// 商务合作注册
export function cooperationRegister(data) {
  return request({
    url: "/usercenter/v1/agentAccountReview",
    method: "post",
    data,
  });
}

// 商务合作登录专业代后台url
export function cooperationLogin(data) {
  return request({
    url: "/usercenter/v1/proAgentBackendDomain",
    method: "post",
    data,
  });
}

// 商务合作联系方式
export function cooperationCustomerContact(data) {
  return request({
    url: "/usercenter/v1/promotion/CustomerContact",
    method: "post",
    data,
  });
}

// 三方登陆google
export function googleLoginService(data) {
  const obj = {
    ...data,
    app: "web",
    inviteCode: getLocalStorage("inviteCode") || "",
  };
  fromAppFormat(obj);
  return request({
    url: "/usercenter/v1/register/google",
    method: "post",
    data: {
      ...obj,
    },
  });
}

// 三方登陆tron
export function tronLoginService(data) {
  const obj = {
    ...data,
    app: "web",
    inviteCode: getLocalStorage("inviteCode") || "",
  };
  fromAppFormat(obj);
  return request({
    url: "/usercenter/v1/register/tron",
    method: "post",
    data: {
      ...obj,
    },
  });
}

// 根据registor_promotion_token 获取 token
export function getTokenByPromotion(data) {
  return request({
    url: "/usercenter/v1/login/getToken",
    method: "post",
    data: {
      ...data,
    },
  });
}